// React and Redux Dependencies
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Redux Actions
import { getBudgetExport, setModal } from 'reduxStore/actions/budgetManagement';

// Utilities
import { saveSelectedBudgetsToSession } from 'UtilityComponents/budgetUtils';
import { getPluralText } from 'UtilityComponents/Util';

// Internal Components
import Filters from '../Filters';
import BudgetOverviewItemComponent from '../BudgetOverviewItem';
import BudgetOverviewListing from '../../BudgetTable';

//  UI Components & Styles
import ButtonComp from 'common/Button/Button';
import { FlexDiv, GenericDiv, GenericP } from 'commonStyles';

import {
    BudgetOverviewContainer,
    HeadingDtls,
    TopSection,
    BudgetSelectedWrapper,
    BudgetOverview,
} from '../../styles';

// Config
import { textsConfig } from '../../config';
import StatusPopup from 'common/statusPopup/statusPopup';
import { BUDGET_CONSTANTS, PATHS } from 'AppConstants';


const BudgetOverviewSection = () => {
    const dispatch = useDispatch();

    const { selectedRecords = {}, filters = {} } = useSelector(
        (state) => state?.budgetManagement || {}
    );
    const successMessage = useSelector((state) => state?.budgetManagement?.exportSuccessMessage || '');
    
    const {
        budgetList = [],
    } = useSelector((state) => state?.budgetManagement || {});

    const selectedCount = Object.keys(selectedRecords).length;
    const budgetCount = budgetList?.data?.length || 0;

    /** Build export payload (optimized with useMemo) */
    const exportPayload = useMemo(() => {
        const query = {};

        Object.values(filters).forEach(({ value, filterKey }) => {
            if (value) query[filterKey] = value;
        });

        return {
            query,
            limit: 20,
            offset: 0,
        };
    }, [filters]);

    const handleExportData = () => {
        dispatch(getBudgetExport(exportPayload));
    };
    
    const handleViewReports = () => {
        saveSelectedBudgetsToSession(budgetList?.data, selectedRecords);
        window.location = PATHS.BUDGET_MANAGEMENT_REPORT;
    }
    return (
        <BudgetOverviewContainer>
            <TopSection>
                <HeadingDtls>
                    <GenericP fsize="22px" f_weight="900" $lHeight="28px" color="#000 !important">{textsConfig.BUDGET_OVERVIEW}</GenericP>
                    <GenericP color="#757575 !important" $lHeight="20px">{textsConfig.PAGE_SUB_HEAD_TEXT}</GenericP>
                </HeadingDtls>
            </TopSection>

            <BudgetOverview gap="16px">
                <BudgetOverviewItemComponent />
            </BudgetOverview>

            <Filters />

            <BudgetSelectedWrapper>
                <FlexDiv justify="space-between" align="center">
                    <GenericDiv as="h3" fsize="14px" f_weight="900" color="#4A4A4A"> 
                        {selectedCount > 0 
                            ? `${selectedCount} ${getPluralText('Budget', selectedCount)} Selected`
                            : `${budgetCount} ${getPluralText('Budget', budgetCount)} Found`
                        }
                    </GenericDiv>
                    <FlexDiv gap="10px" justify="flex-end" $width="50%">
                        <ButtonComp
                            btnWidth="135px"
                            btnTxt={textsConfig.VIEW_REPORTS}
                            height="40px"
                            btnType="Flat"
                            btnName="Secondary"
                            padding="0"
                            handleClick={handleViewReports}
                            disabled={selectedCount === 0}
                        />

                        <ButtonComp
                            btnWidth="135px"
                            btnTxt={textsConfig.EXPORT_DATA}
                            height="40px"
                            btnType="Flat"
                            btnName="Secondary"
                            margin="0 16px"
                            padding="0"
                            handleClick={handleExportData}
                        />
                    </FlexDiv>
                </FlexDiv>
            </BudgetSelectedWrapper>
            <BudgetOverviewListing />
            {
                successMessage && (
                    <StatusPopup
                        handleModal={() => {
                            dispatch(setModal({ modalType: '' }));
                        }}
                        heading={BUDGET_CONSTANTS.SUCCESS_MODAL}
                        apiStatus={BUDGET_CONSTANTS.SUCCESS_MODAL}
                        content={successMessage}
                        isLoading={false}
                        isFooter={false}
                    />
                )
            }
        </BudgetOverviewContainer>
    );
};

export default BudgetOverviewSection;
